import { getUrlForPageId } from '../../../../../../app/pages/ui/utils/getUrlForPageId';
import { ISiteMap } from '../../../../../../app/pages/domain/models/ISiteMap';
import { PASSENGERS_SHOP_DINE_AND_RELAX_DETAIL_PAGE_ID } from '../../../../../../shared/api/contentful/constants';
import { getMapUrlForPoiId } from '../../../../detail/helpers/getMapUrlForPoiId';
import { ILocale } from '../../../../../../shared/i18n/locale/models/ILocale';

export type PoiLinkPropsType = { href: string; target?: string };

export const getPoiLinkProps = (
	currentLocale: ILocale,
	poiId: string,
	onTablet: boolean,
	siteMap: ISiteMap,
): PoiLinkPropsType => {
	if (onTablet) {
		return { href: getMapUrlForPoiId(currentLocale, poiId), target: '_blank' };
	}
	const baseUrl = getUrlForPageId(
		PASSENGERS_SHOP_DINE_AND_RELAX_DETAIL_PAGE_ID,
		siteMap,
	);
	return { href: `${baseUrl}?poiId=${poiId}` };
};
